module.exports = __webpack_public_path__ + "img/icon_real_time_3.494a0da5.png";